import api from '../api/axios';
import { SugerenciaEnviada, SugerenciaInput } from '../types/sugerencia';

export const sugerenciaService = {
  /** Envía una sugerencia de mejora (el backend la reenvía a Faro). */
  crear: async (input: SugerenciaInput): Promise<SugerenciaEnviada> => {
    const { data } = await api.post<SugerenciaEnviada>('sugerencias/', input);
    return data;
  },

  /** Marca que la persona ya vio el aviso de la funcionalidad. */
  marcarAvisoVisto: async (): Promise<void> => {
    await api.post('me/aviso-sugerencias/');
  },
};
